import { combineReducers, Reducer } from 'redux';

import { IAction } from '../../../types';
import {
    GET_PERFEED_REQUESTS_SUCCESS,
    PERFEED_REQUESTS_CHANGE_PAGE,
    GET_PERFEED_REQUESTS_SETTINGS_SUCCESS,
    SAVE_PERFEED_REQUESTS_SETTINGS_SUCCESS,
} from '../../../actions/PerfeedActions';

import ratingPoint from './ratingPoint';

const mockList = [
    {
        id: 1,
        names: ['Amelia Smith'],
        project: 'meeting PM',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
    {
        id: 2,
        names: ['Emily Roberts', 'Amelia Smith', 'Evie Hall'],
        project: 'Project',
        date: '2019-07-18T14:20',
        status: 'edit',
        message: 'Please give me feedback, thanks',
    },
    {
        id: 3,
        names: ['Emily Roberts', 'Amelia Smith'],
        project: 'Sales meeting',
        date: '2019-07-18T14:20',
        status: 'edit',
        message: 'Please give me feedback, thanks',
    },
];

const items = (state = mockList, action: IAction) => {
    switch (action.type) {
        case GET_PERFEED_REQUESTS_SUCCESS:
            return state; // return action.payload as [];
        default:
            return state;
    }
};

const paginationState = {
    page: 0,
    pages: 0,
    totalElements: 0,
    start: 0,
    end: 0,
};

const pagination = (state = paginationState, action: IAction) => {
    switch (action.type) {
        case GET_PERFEED_REQUESTS_SUCCESS:
            return Object.assign({}, state, {
                pages: 10,
                totalElements: 133,
                start: state.page * 20,
                end: state.page * 20 + 20,
            }); // return action.payload.pagination;
        case PERFEED_REQUESTS_CHANGE_PAGE:
            return Object.assign({}, state, { page: action.payload as number });
        default:
            return state;
    }
};

const list = combineReducers({ items, pagination });

type SettingsState = {
    email: number;
};

const settings: Reducer<SettingsState, IAction> = (
    state: SettingsState = { email: 1 },
    action: IAction,
) => {
    switch (action.type) {
        case GET_PERFEED_REQUESTS_SETTINGS_SUCCESS:
            return state; // return action.payload as [];
        case SAVE_PERFEED_REQUESTS_SETTINGS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({ list, settings, ratingPoint });
